import { Fragment } from 'react'
import { Tooltip } from 'react-tooltip'
import './CharacteristicsL2.scss'

const CharacteristicsL2 = ({ list, size = 'medium', classNames }) => {
  const addSeparator = index => index < list.length - 1

  // Check if this is a rating characteristic - we need to add more reliable detection
  const isRatingItem = item => {
    // Check if the item has an icon AND has a numeric label (rating)
    return (
      item.icon &&
      !isNaN(parseFloat(item.label)) &&
      typeof item.label === 'string'
    )
  }

  const hasRating = list.length === 1 && isRatingItem(list[0])
  const tooltipId = hasRating
    ? `customer-rating-tooltip-${Math.random()
        .toString(36)
        .substr(2, 9)}`
    : undefined

  return (
    <div className={`characteristics-l2 ${classNames || ''}`}>
      {list.map((item, index) => {
        const isRating = isRatingItem(item)
        const itemTooltipId = isRating ? tooltipId : undefined

        return (
          <Fragment key={`ch-l2-${index}`}>
            <div
              className={`characteristics-l2__item characteristics-l2__item--${size}`}
              {...(itemTooltipId ? { 'data-tooltip-id': itemTooltipId } : {})}>
              {item.icon} {item.label}
            </div>
            {addSeparator(index) && (
              <div className="characteristics-l2__separator" />
            )}
          </Fragment>
        )
      })}

      {hasRating && (
        <Tooltip
          id={tooltipId}
          className="tooltip__theme-dark characteristics-l2__tooltip"
          opacity={1}
          place="top">
          <div className="characteristics-l2__tooltip-content">
            <div>Customers rating: ★ {list[0].label}</div>
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export { CharacteristicsL2 }
